import { OtherItemHeaderStyles } from './OtherItemHeader.types'

const makeStyles = (): OtherItemHeaderStyles => ({
	subItem: {
		width: '250px'
	}
})

export default makeStyles
